export default __webpack_public_path__ + "assets/ico_updates-913df341.svg";